module.exports = __webpack_public_path__ + "img/confirm_bg.2fa6dae5.png";